import { DatePicker, Select } from "@rio-cloud/rio-uikit";
import moment, { Moment } from "moment";
import { AsyncPaginate } from "react-select-async-paginate";
import type { GroupBase } from 'react-select';
import { FormFields, IPagedSelectOptionItens } from "../../../../models/newSupportCall";
import useNewSupportCall from "../../../../hooks/useNewSupportCall";
import { optionsAdministrative, optionsFinancial, optionsVolksTotalPortal, SupportType } from "../../../support/constants";
import SelectCustom from "../../../../components/selectCustom";
import { formatPhoneNumber } from "../../../../utils/phoneUtils";

export interface IAdministrativeFormData {
	formData: FormFields;
	errors: Partial<Record<keyof FormFields, string>>;
	subject: string;
	updateField: <K extends keyof FormFields>(field: K, value: FormFields[K]) => void;
	name: string;
    fetchVehicle: (chassis: string) => Promise<void>
}

const AdministrativeForm = ({ formData, errors, updateField, subject, name, fetchVehicle }: IAdministrativeFormData) => {

	const { 
		getSupportRegionals,
		selectedRegional,
		setSelectedRegional,
		dnOptions,
		getAllDns,
		role,
    } = useNewSupportCall();

	const updateResponsible = (value: string) => updateField('responsible', value);
	const updateChassis = (value: string) => {
        updateField('chassis', value);
        if(value.length === 17){
            fetchVehicle(value);
        }
    };
	const updateLicensePlate = (value: string) => updateField('licensePlate', value);
	const updateDn = (value: string) => updateField('dn', value);
	const updateCustomer = (value: string) => updateField('customer', value);
	const updateHourMeter = (value: string) => updateField('hourMeter', value);
	const updateOdometer = (value: string) => updateField('odometer', value);
	const updateEntryDate = (value: Moment | string) => updateField('entryDate', value);
	const updateRegionalId = (value: string) => updateField('regionalId', value);
	const updateRequestDetail = (value: string) => updateField('requestDetail', value);
	const updateSubtopic = (value: string) => updateField('subtopic', value);
	const updatePhone = (value: string) => updateField('phone', value);
	const updateDnResponsible = (value: string) => updateField('dnResponsible', value);
    const updateCustomerComment = (value: string) => updateField('customerComment', value);

	// const getThemeSelectOptions = () => {
	// 	if(subject === SupportType.ADMINISTRATIVE){
	// 		return optionsAdministrative.map(option => {
	// 			return (
	// 				<option value={option.id}>{option.label}</option>
	// 			)
	// 		})
	// 	}

	// 	if(subject === SupportType.FINANCIAL){
	// 		return optionsFinancial.map(option => {
	// 			return (
	// 				<option value={option.id}>{option.label}</option>
	// 			)
	// 		})
	// 	}

	// 	if(subject === SupportType.PORTAL){
	// 		return optionsVolksTotalPortal.map(option => {
	// 			return (
	// 				<option value={option.id}>{option.label}</option>
	// 			)
	// 		})
	// 	}

	// 	return ''
	// }
	
	return (
		<>
			<div className='padding-y-15 padding-x-15 rounded border'>
				{/* {subject !== SupportType.COMMERCIAL ? (
					<div className=''>
						<p className='text-size-14 text-color-darker'>Tema</p>
						<div className='form-group display-flex padding-top-10'>
							<select
								className='form-control'
								value={formData.subtopic}
								onChange={event => updateSubtopic(event.target.value)}
							>
								{getThemeSelectOptions()}
							</select>
						</div>
					</div>
				) : null} */}
				<div className='display-flex justify-between flex-wrap gap-20'>
                    <div className='form-group flex-1-1'>
                        <label className='text-size-14 text-color-darker margin-bottom-10'>
                            Responsável*
                        </label>
                        <input
                            type='text'
                            className='form-control'
                            placeholder="Obrigatório"
                            value={name || formData.responsible}
                            disabled={Boolean(name?.trim())}
                            onChange={event => updateResponsible(event.target.value)}
                        />
                        {errors.responsible && (
                            <span className='text-size-12 text-color-danger'>{errors.responsible}</span>
                        )}
                    </div>
                    <div className='form-group flex-1-1 max-width-25pct'>
                        <label className='text-size-14 text-color-darker margin-bottom-10'>Dn*</label>
                        {role === 'GROUP_CONSULTANT' || role === 'CONSULTANT' ? (
                            <div className='justify-between flex flex-col'>
                                <Select
                                    value={formData.dn ? [formData.dn] : []}
                                    onChange={option => updateDn(option?.id || '')}
                                    options={dnOptions?.map(dnItem => ({
                                        id: dnItem.value,
                                        label: dnItem.label
                                    }))}
                                    placeholder="Selecione"
                                />
                            </div>
						) : null}

                        {role === 'TOWER' || role === 'FACTORY' ? (
							<SelectCustom
								value={[formData.dn || '']}
								onChange={(item) => {updateDn(item?.id || '')}}
								loadData={getAllDns}
								disabled={false}
								isRemoved={false}
								loadOnFocus={true}
								openOnFocus={false}
								autoFocus={false}
								initialLimit={10}
								placeholder="Digite para buscar opcões"
								inputBorderColor="#d0d8de"
								inputBackgroundColor="#ffffff"
								dropdownBackgroundColor="#ffffff"
								highlightedOptionColor="#3b82f6"
								selectedOptionColor="#e5e7eb" 
							/>
						) : null}

                        {errors.dn && (
                            <span className='text-size-12 text-color-danger'>{errors.dn}</span>
                        )}
                    </div>
                    <div className='form-group flex-1-1 margin-x-10'>
                        <label className='text-size-14 text-color-darker margin-bottom-10'>
                            Chassi do veículo
                        </label>
                        <input
                            type='text'
                            className='form-control'
                            placeholder="Opcional"
                            value={formData.chassis}
                            onChange={event => updateChassis(event.target.value)}
                    		maxLength={17}
                        />
                        {errors.chassis && (
                            <span className='text-size-12 text-color-danger'>{errors.chassis}</span>
                        )}
                    </div>
                    <div className='form-group flex-1-1'>
                        <label className='text-size-14 text-color-darker margin-bottom-10'>
                            Placa do veículo
                        </label>
                        <input
                            type='text'
                            className='form-control'
                            value={formData.licensePlate}
                            onChange={event => updateLicensePlate(event.target.value)}
                            placeholder="Opcional"
                        />
                        {errors.licensePlate && (
                            <span className='text-size-12 text-color-danger'>{errors.licensePlate}</span>
                        )}
                    </div>
                </div>
                <div className='display-flex justify-between flex-wrap gap-20'>
                    <div className='form-group flex-1-1 max-width-350'>
                        <label className='text-size-14 text-color-darker margin-bottom-10'>
                            Responsável pelo chamado no DN
                        </label>
                        <input
                            type='text'
                            className='form-control'
                            value={formData.dnResponsible}
                            onChange={event => updateDnResponsible(event.target.value)}
                            style={{ height: '39px' }}
                            placeholder="Opcional"
                        />
                        {errors.dnResponsible && (
                            <span className='text-size-12 text-color-danger'>{errors.dnResponsible}</span>
                        )}
                    </div>
                    <div className='form-group flex-1-1 margin-x-10'>
                        <label className='text-size-14 text-color-darker margin-bottom-10'>
                            Tel para contato *
                        </label>
                        <input
                            type='text'
                            className='form-control'
                            placeholder="Obrigatório"
                            value={formData.phone}
                            onChange={event => { 
                                const value = formatPhoneNumber(event.target.value)
                                updatePhone(value)
                            }}
                            style={{ height: '39px' }}
                        />
                        {errors.phone && (
                            <span className='text-size-12 text-color-danger'>{errors.phone}</span>
                        )}
                    </div>
                    <div className='form-group flex-1-1 max-width-350'>
                        <label className='text-size-14 text-color-darker margin-bottom-10'>
                            Nome do cliente
                        </label>
                        <input
                            type='text'
                            className='form-control'
                            value={formData.customer}
                            onChange={event => updateCustomer(event.target.value)}
                            style={{ height: '39px' }}
                            placeholder="Opcional"
                        />
                        {errors.customer && (
							<span className='text-size-12 text-color-danger'>{errors.customer}</span>
						)}
                    </div>
                    <div className='form-group flex-1-1 max-width-350'>
                        <div>
                            <p className='text-size-14 text-color-darker margin-0'>Regional *</p>
                            <div className='form-group margin-0 display-flex padding-top-10'>
                                <AsyncPaginate<IPagedSelectOptionItens, GroupBase<IPagedSelectOptionItens>, unknown>
                                    className='w-full'
                                    value={selectedRegional}
                                    loadOptions={getSupportRegionals}
                                    onChange={value => {
                                        const valueSelected = value?.value ? String(value?.value) : '';

                                            setSelectedRegional(value);
                                            updateRegionalId(valueSelected);
                                    }}
                                    placeholder='Selecione a regional'
                                />
                            </div>
                            {errors.regionalId && (
                                <span className='text-size-12 text-color-danger'>{errors.regionalId}</span>
                            )}
                        </div>
                    </div>
                </div>
                <div className='display-flex justify-between flex-wrap gap-20'>
                    <div className='form-group margin-0 flex-1-1 max-width-350'>
                        <label className='text-size-14 text-color-darker margin-bottom-10'>Horímetro</label>
                        <input
                            type='text'
                            className='form-control'
                            value={formData.hourMeter}
                            onChange={event => updateHourMeter(event.target.value)}
                            placeholder="Opcional"
                        />
                        {errors.hourMeter && (
                            <span className='text-size-12 text-color-danger'>{errors.hourMeter}</span>
                        )}
                    </div>
                    <div className='form-group margin-0 flex-1-1 margin-x-10'>
                        <label className='text-size-14 text-color-darker margin-bottom-10'>Km</label>
                        <input
                            type='text'
                            className='form-control'
                            value={formData.odometer}
                            onChange={event => updateOdometer(event.target.value)}
                            placeholder="Opcional"
                        />
                        {errors.odometer && (
                            <span className='text-size-12 text-color-danger'>{errors.odometer}</span>
                        )}
                    </div>
                    <div className='form-group margin-0 flex-1-1 max-width-350'>
                        <label className='text-size-14 text-color-darker margin-bottom-10'>
                            Data de entrada do veículo
                        </label>
                        <DatePicker
                            id='tech'
                            inputProps={{ placeholder: 'Selecione' }}
                            dateFormat='DD/MM/YYYY'
                            timeFormat={false}
                            onChange={(result: Moment | string) => updateEntryDate(result)}
                            isValidDate={(currentDate: Moment) => currentDate.isSameOrBefore(moment(), 'day')}
                            className="margin-0"
                        />
                        {errors.entryDate && (
                            <span className='text-size-12 text-color-danger'>{errors.entryDate}</span>
                        )}
                    </div>
                </div>
			</div>
			<div className='margin-top-20'>
				<p className='text-size-16 text-bold'>2. Dados adicionais</p>
					<div className='padding-15 margin-top-20 rounded border'>
						<div className='display-flex justify-between flex-wrap gap-20'>
								
							</div>
						<div>
							<p className='text-size-14 text-color-darker'>Detalhe da solicitação</p>
							<textarea 
								className="form-control margin-top-10" 
								rows={3} 
								id="textArea" 
								placeholder="Opcional"
								value={formData.customerComment}
								onChange={event => updateCustomerComment(event.target.value)}
							></textarea>
						</div>
					</div>
			</div>
		</>
	)
}

export default AdministrativeForm;